import React, { useEffect } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import HealingIcon from '@mui/icons-material/Healing';

const QuejasSection = ({
  quejasRecords,
  terminadoRecords,
  isFormOpen,
  setIsFormOpen,
  fechaQueja,
  setFechaQueja,
  noQueja,
  setNoQueja,
  noLote,
  setNoLote,
  descripcionProducto,
  setDescripcionProducto,
  detalleQueja,
  setDetalleQueja,
  fechaAtencion,
  setFechaAtencion,
  medidasCorrectivas,
  setMedidasCorrectivas,
  handleSaveQueja
}) => {

  // Auto-fill from finished records if available
  useEffect(() => {
    if (noLote && noLote !== "manual") {
      const selected = terminadoRecords.find(r => r.loteEnvasado === noLote);
      if (selected) {
        setDescripcionProducto(`${selected.marca} - ${selected.categoria} ${selected.claseEtiqueta} (${selected.capacidad})`);
      }
    }
  }, [noLote, terminadoRecords, setDescripcionProducto]);

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Quejas Acerca del Producto Certificado (Sección IX)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Registrar Nueva Queja</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha Queja</th>
                <th>Nº de Queja</th>
                <th>Nº de Lote</th>
                <th>Descripción del Producto</th>
                <th>Detalle de la Queja</th>
                <th>Fecha Atención</th>
                <th>Medidas Correctivas Implementadas</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {quejasRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.id}</td>
                  <td>{rec.fechaQueja}</td>
                  <td style={{ fontWeight: 800 }}>{rec.noQueja}</td>
                  <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.noLote}</td>
                  <td>{rec.descripcionProducto}</td>
                  <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={rec.detalleQueja}>
                    {rec.detalleQueja}
                  </td>
                  <td>{rec.fechaAtencion || "-"}</td>
                  <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={rec.medidasCorrectivas}>
                    {rec.medidasCorrectivas || "-"}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nueva Queja / Reclamación de Producto - Sección IX</h2>
      </div>

      <div className="cards-container-grid">
        {/* IDENTIFICACION */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <ReportProblemIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Detalles de la Queja</h2>
              <p>Fecha, folio e identificación del producto afectado</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaQueja} 
                onChange={e => setFechaQueja(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha de Recepción</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={noQueja} 
                onChange={e => setNoQueja(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. QJ-2026-004"
              />
              <label className="custom-input-label">Nº de Queja</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={noLote} 
                onChange={e => setNoLote(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="manual">Ingreso Manual (Lote no listado)</option>
                {terminadoRecords.map((r, idx) => (
                  <option key={idx} value={r.loteEnvasado}>
                    {r.loteEnvasado} ({r.marca})
                  </option>
                ))}
              </select>
              <label className="custom-input-label">Nº de Lote Afectado</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={descripcionProducto} 
                onChange={e => setDescripcionProducto(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Mezcal Artesanal Joven 750ml"
              />
              <label className="custom-input-label">Descripción del Producto</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={detalleQueja} 
              onChange={e => setDetalleQueja(e.target.value)} 
              className="custom-input-field"
              style={{ height: "100px", resize: "none", padding: "14px" }}
              placeholder="Describa el motivo de la queja, desviación reportada, etc..."
            />
            <label className="custom-input-label">Detalle de la Queja</label>
          </div>
        </section>

        {/* ATENCION Y MEDIDAS CORRECTIVAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <HealingIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Atención y Acciones Correctivas</h2>
              <p>Seguimiento, fechas de respuesta y medidas implementadas</p>
            </div>
          </header>

          <div className="custom-input-group" style={{ marginBottom: 20 }}>
            <input 
              type="date" 
              value={fechaAtencion} 
              onChange={e => setFechaAtencion(e.target.value)} 
              className="custom-input-field"
            />
            <label className="custom-input-label">Fecha de Atención</label>
          </div>

          <div className="custom-input-group">
            <textarea 
              value={medidasCorrectivas} 
              onChange={e => setMedidasCorrectivas(e.target.value)} 
              className="custom-input-field"
              style={{ height: "140px", resize: "none", padding: "14px" }}
              placeholder="Describa las acciones correctivas aplicadas (ej. retiro de lote, re-etiquetado, análisis de laboratorio)..."
            />
            <label className="custom-input-label">Medidas Correctivas Implementadas</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveQueja("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Queja Sección IX</span>
        </button>
      </div>
    </div>
  );
};

export default QuejasSection;
